/* 
    Hub instance allows components to talk to each without polluting the global.
 */
define('shared/util/hub',['shared/lib/Emitter', 'shared/lib/RSVP'], function (Emitter, RSVP) {
    'use strict';

    var data = {};

    var hub = {
        /*
            Get value from specified channel when it is set
            @return promise which will be resolved when channel has been set
        */
        get: function(chn) {
            if ( chn in data ) {
                return RSVP.resolve(data[chn]);
            }
            else {
                return new RSVP.Promise(function(resolve) {
                    function handler(innerChn, value){
                        if ( innerChn === chn ) {
                            resolve( value );
                            hub.off('changed', handler);
                        }
                    }
                    hub.on('changed', handler);
                });
            }
        },
        /*
            Get value from specified channel
            @return promise which will be resolved immediately no matter if the channel has been set
        */
        peek: function(chn) {
            return data[chn];
        },
        /*
            Set value to specified channel
            @return promise which will be resolve when setting is done
        */
        set: function(chn, value) {
            if ( data[chn] !== value ) {
                hub.emit('change', chn, value);
                data[chn] = value;
                hub.emit('changed', chn, value);
            }
            return RSVP.resolve();
        }
    };


    new Emitter(hub);

    return hub;
});
